import React, { useEffect, useState } from "react";
import QuoteChoosePlanPopup from "../../../../component/popups/quote_choose_plan";
import { actionQuoteList, resetQuoteList } from "./store";
import { useDispatch, useSelector } from "react-redux";
import {
  TOAST_DURATION,
  TOAST_POSITION,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";

const QuoteComponent = (props) => {
  const currentUrl = window.location.href;
  const segments = currentUrl.split("/");
  const [documentBulk, setDocumentBulk] = useState(false);
  const lastSegment = segments[segments.length - 1];
  const policyId = parseInt(lastSegment);
  const [quotesCard, setQuotesCard] = useState();
  const [selectedPlan, setSelectedPlan] = useState();
  const [featureMaster, setFeatureMaster]= useState([]) 

  // const FEATURE_MASTER = [
  //   {
  //     id: 1,
  //     name: "Own Damage Cover",
  //     detail:
  //       "This feature helps to cover damages from accidents, man-made disasters, and natural disasters",
  //   },
  //   {
  //     id: 2,
  //     name: "Basic TP cover",
  //     detail:
  //       "Third party liability insurance policy is an insurance plan that provides you with coverage against third-party liabilities. This policy is mandtory as per Motor Laws applicable in India. A third party insurance policy typically covers the following damages:\n1.Damages to third-party property, including their vehicle \n2.Injuries to third-party persons \n3.The death of a third-party person",
  //   },
  //   {
  //     id: 3,
  //     name: "LL-Paid Driver Cover",
  //     detail:
  //       "This personal accident coverage is for the driver you have hired to drive your car. The sum insured is payable only to the driver who you have declared as the driver in the proposal application",
  //   },
  //   {
  //     id: 4,
  //     name: "Depreciation Reimbursement",
  //     detail:
  //       "This add-on covers the depreciation cost deducted from your car's parts during claims, excluding the first two claims from the depreciation deduction.",
  //   },
  //   {
  //     id: 5,
  //     name: "Return To Invoice",
  //     detail:
  //       "This covers the difference between the car's purchase price and compensation due to depreciation and may cover the gap for a new car of the same make and model. This cover is applicable only for the first owner.",
  //   },
  //   {
  //     id: 6,
  //     name: "Consumable Expenses",
  //     detail:
  //       "Covers the cost of replenishing consumables like gearbox oil, nuts & bolts, oil filter, etc., during claims.",
  //   },
  //   {
  //     id: 7,
  //     name: "Engine Secure",
  //     detail:
  //       "Covers repair or replacement costs for the engine if damaged by water, ideal for flood-prone areas. This cover comes with an dedcutible",
  //   },
  //   {
  //     id: 8,
  //     name: "Tyre Secure",
  //     detail:
  //       "Covers financial damages to car tires or tubes due to accidental damage.",
  //   },
  //   {
  //     id: 9,
  //     name: "Road Side Assistance",
  //     detail:
  //       "This covers the difference between the car's purchase price and compensation due to depreciation and may cover the gap for a new car of the same make and model. This cover is applicable only for the first owner.",
  //   },
  //   {
  //     id: 10,
  //     name: "Key Replacement",
  //     detail:
  //       "Covers replacement costs for lost car keys to prevent potential car theft.",
  //   },
  // ];
  const dispatch = useDispatch();
  const { quoteList, submitQuote } = useSelector((state) => ({
    ...state.quoteListStore,
  }));

  useEffect(() => {
    if (props.from == "policy") {
      dispatch(actionQuoteList({ policy_id: policyId }));
    } else if (props.from == "quote") {
      dispatch(actionQuoteList({ quote_id: policyId }));
    }
  }, []);

  useEffect(() => {
    if (quoteList) {
      dispatch(resetQuoteList());
      if (quoteList.status) {
        setQuotesCard(quoteList.data?.quotes);
        setFeatureMaster(quoteList.data?.plan_features);
      } else {
        toast.error("Error in Fetching Data", {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [quoteList]);

  return (
    <>
      {/* START: IF Quote type = new  this is only for standalone quote*/}
      {props.from == "quote" && (
        <div className="mt-6">
          {quotesCard?.length > 0 && (
            <div className="mb-4">
              <h6 className="text-primary">Vehicle Details</h6>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 mt-2 mt-md-0">
                      Quote Type :{" "}
                      <b className="text-primary">
                        {quotesCard[0].quote_type
                          ? quotesCard[0].quote_type
                          : "-"}
                      </b>
                    </div>
                    <div className="col-md-3 mt-2 mt-md-0">
                      Insured Name :{" "}
                      <b>
                        {quotesCard[0].insured_name
                          ? quotesCard[0].insured_name
                          : "-"}
                      </b>
                    </div>
                    <div className="col-md-3 mt-2 mt-md-0">
                      {/* Make & Model : <b>{quotesCard[0].make && quotesCard[0].model ? `${quotesCard[0].make} - ${quotesCard[0].model}` : "-"}</b> */}
                      Make & Model :{" "}
                      <b>
                        {" "}
                        {quotesCard[0].make &&
                        quotesCard[0].model &&
                        quotesCard[0].variant
                          ? `${quotesCard[0].make} - ${quotesCard[0].model} - ${quotesCard[0].variant}`
                          : quotesCard[0].make && quotesCard[0].model
                          ? `${quotesCard[0].make} - ${quotesCard[0].model}`
                          : "-"}
                      </b>
                    </div>
                    <div className="col-md-3 mt-2">
                      Fuel Type :{" "}
                      <b>
                        {quotesCard[0].fuel_type
                          ? quotesCard[0].fuel_type
                          : "-"}
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {/* END: IF Quote type = new */}

      <div>
        <h6 className="text-primary">Choose Quotes</h6>
      </div>
      {quotesCard?.length
        ? quotesCard.map((quote, index) => (
            <div className="col-12 col-md-4">
              <div className="card text-center w-100 h-100" key={index}>
                <h6 className="mb-0 mt-3">{`Plan ${index + 1}: ${
                  quote.plan.name
                }`}</h6>
                <div className="card-body px-0">
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">IDV</p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.current_total_idv) &&
                            Number(quote?.current_total_idv).toFixed(0)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          Net OD Premium
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.net_od_premium) &&
                            Number(quote?.net_od_premium).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          Net TP Premium
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.net_tp_premium) &&
                            Number(quote?.net_tp_premium).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          Net Add On Premium
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.add_on_premium) &&
                            Number(quote?.add_on_premium).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          OD Discount %
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {quote?.discount && quote?.discount}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          Net Premium
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.total_od_tp_add_on) &&
                            Number(quote?.total_od_tp_add_on).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          GST 18%
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.gst_od_tp_add_on) &&
                            Number(quote?.gst_od_tp_add_on).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container color-row" key={index}>
                    <div key={index} className="row cust-pink-100 pt-2 border ">
                      <div className="col-8 text-start">
                        <p className="cust-fs-14 font-weight-bold mb-1">
                          Gross Premium
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="cust-fs-14 fw-bold mb-1">
                          {!isNaN(quote?.total_premium_with_tax_add_on) &&
                            Number(
                              quote?.total_premium_with_tax_add_on
                            ).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="container px-3">
                    <div className="px-3">
                      <div className="pt-3">
                        <p className="cust-fs-16 text-start">
                          <b>Features:</b>
                          {featureMaster!=null && featureMaster.length && featureMaster.map((feature, index) => {
                            const isFeatureIncluded =
                              quote?.plan?.planFeatures?.some(
                                (addonFeature) => addonFeature.id === feature.id
                              );
                            return (
                              <div key={index}>
                                {isFeatureIncluded ? (
                                  <i className="fa fa-check me-2 text-success"></i>
                                ) : (
                                  <i className="fa fa-close me-2 text-danger"></i>
                                )}
                                {feature.name}
                              </div>
                            );
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    {/*buy now button */}
                    <button
                      className="btn cust-primary-bg text-white text-center"
                      data-bs-toggle="modal"
                      data-bs-target="#quoteChoosePlan"
                      onClick={() => {
                        setSelectedPlan(quote);
                        setDocumentBulk(true);
                      }}
                    >
                      Choose Plan
                    </button>
                      {quote?.add_on_remarks && (
                        <>
                         <p className="mt-2 ">
                          Remark :{" "}
                          {quote?.add_on_remarks
                            ? quote?.add_on_remarks
                            : "No Remark"}
                            </p>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          ))
        : null}

      <QuoteChoosePlanPopup
        policyPreviousData={props?.policyPreviousData}
        selectedPlan={selectedPlan}
        show={documentBulk}
        handleClose={() => {
          setDocumentBulk(false);
        }}
      />
    </>
  );
};

export default QuoteComponent;
